import designTokens from '@customink/design-tokens/build/js/designTokens';
import { groupedClassName, sizeLargeClassName } from './utils';
var themeOptions = function (theme) {
    var _a;
    return ({
        components: {
            MuiAvatar: {
                styleOverrides: {
                    root: (_a = {
                            alignItems: 'center',
                            color: designTokens.color.gray.obsidian.value,
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            fontSize: theme.spacing(1.375),
                            lineHeight: theme.spacing(1.75),
                            textAlign: 'center',
                            letterSpacing: '0.015em',
                            height: theme.spacing(3.25),
                            width: theme.spacing(3.25)
                        },
                        _a["&.".concat(sizeLargeClassName)] = {
                            fontSize: theme.spacing(1.75),
                            lineHeight: theme.spacing(2.5),
                            height: theme.spacing(5),
                            width: theme.spacing(5),
                        },
                        _a[".MuiAvatarGroup-root &.".concat(groupedClassName)] = {
                            // first-child makes React unhappy. Since there is only one type of child, using first-of-type is safe (same applies for last)
                            '&:first-of-type': {
                                marginLeft: '0',
                            },
                            '&:last-of-type': {
                                marginLeft: theme.spacing(-1),
                            },
                        },
                        _a),
                },
            },
        },
    });
};
export default themeOptions;
//# sourceMappingURL=avatarTheme.js.map